__turbopack_context__.v({
  "article": "TuZxpG_article",
  "article-section": "TuZxpG_article-section",
  "button-group": "TuZxpG_button-group",
  "card-grid": "TuZxpG_card-grid",
  "show-more": "TuZxpG_show-more",
});
